import { forwardRef } from 'react';

import { cn } from '../../../utils/cn';

type Props = {
    children: React.ReactNode;
    ref?: React.ForwardedRef<HTMLTableRowElement>;
    payload: Record<string, unknown>;
    className?: string;
    onAuxClick?: React.MouseEventHandler<HTMLTableRowElement> | undefined;
    onClick?: React.MouseEventHandler<HTMLTableRowElement> | undefined;
    onMouseEnter?: React.MouseEventHandler<HTMLTableRowElement> | undefined;
    'data-testid'?: string;
};

export const DataTableRow = forwardRef<HTMLTableRowElement, Props>(
    ({ children, className, onAuxClick, onClick, onMouseEnter, ...rest }, ref) => {
        return (
            <tr
                ref={ref}
                className={cn(
                    'border-b border-solid border-grey-outline-light last:border-b-0 odd:bg-white even:bg-surface-light',

                    className,
                )}
                onAuxClick={onAuxClick}
                onClick={onClick}
                onMouseEnter={onMouseEnter}
                data-testid={rest['data-testid']}
            >
                {children}
            </tr>
        );
    },
);
